import { BonecallerRitual } from "game-common/bonecaller_combat"
import { AbstractRenderer, Graphics, RenderTexture, Texture } from "pixi.js"

let frames: Texture[] | undefined
const blend = (dark: number, bright: number, amount: number) => [16, 8, 0].reduce((color, shift) =>
    color | Math.round(((dark >> shift) & 255) * (1 - amount) + ((bright >> shift) & 255) * amount) << shift, 0)

/** Procedural art baked once; actual map entity tiles use these shared textures. */
export const bonecallerStoneFrames = (renderer: AbstractRenderer): Texture[] => {
    if (frames) return frames
    frames = []
    const g = new Graphics(), x = 16, y = 30
    for (let i = 0; i <= 10; i++) {
        const energy = i / 10
        g.clear()
        g.lineStyle(2, blend(0x787180, 0x9ee86c, energy), 0.9)
        g.beginFill(0x383041, 1)
        g.drawPolygon([x - 9, y + 10, x - 10, y - 9, x - 3, y - 18,
            x + 7, y - 15, x + 10, y + 8, x, y + 14]); g.endFill()
        g.lineStyle(1.5, 0x99889f, 0.5)
        g.moveTo(x - 3, y - 16); g.lineTo(x - 4, y + 9)
        g.lineStyle(2, blend(0x62536e, 0xc4ff9f, energy), 0.9)
        g.moveTo(x, y + 4); g.lineTo(x, y - 10)
        g.moveTo(x - 5, y - 6); g.lineTo(x, y - 2); g.lineTo(x + 5, y - 6)
        const texture = RenderTexture.create({ width: 32, height: 48 })
        renderer.render(g, { renderTexture: texture, clear: true })
        frames.push(texture)
    }
    g.destroy()
    return frames
}

export const bonecallerStoneEnergy = (ritual: BonecallerRitual | undefined, index: number, now: number, elapsedMs: number) => {
    if (!ritual || index >= ritual.stage) return 0
    const fade = ritual.phase === "active" ? 1 : Math.max(0, 1 - ((ritual.transitionAgeMs ?? Infinity) + elapsedMs) / 1400)
    return fade * (0.8 + 0.2 * Math.sin(now / 200 + index))
}
